module.exports = WebSocketUtils = {
    connect: (wsIp) => {
        // Protocolo por defecto ws://
        return new WebSocket( wsIp.includes('://')? wsIp: `ws://${wsIp}`);
    }
}